import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectRoles, setRolesToState } from 'features/roles/rolesSlice';
import RoleEngine from 'app/role-engine';
import storage from 'helpers/storage';
import { getCookie } from 'helpers/generic.methods';
import { toast } from 'react-toastify';
import { errors } from 'helpers/variables';
import { logout } from 'features/auth/authSlice';
import { globalLogout } from 'helpers/generic-logout-method';
const ProtectedRoute = ({ path, component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const user = JSON.parse(storage.getItem('Profile'));
  const isAuthenticated = !!getCookie('Auth');
  let _hostKey = JSON.parse(storage.getItem('AppMetaInfo'))?.['host'];

  const logoutHandler = () => {
    toast.error(errors.inValidAuthToken);
    globalLogout();
  };

  const { roles } = useSelector(selectRoles);

  useEffect(() => {
    if (user && Object.keys(user).length) {
      const { CompanyRelationship, UserType, UserRoles } = user;
      if (!roles || (roles && !Object.keys(roles).length)) {
        const data = RoleEngine(CompanyRelationship, UserType, UserRoles, user);
        dispatch(setRolesToState(data));
      }
    }
    if (!isAuthenticated && user) {
      logoutHandler();
    }
  }, [roles, user, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && !user) {
      dispatch(logout());
    }
  }, [isAuthenticated, user, dispatch]);

  return (
    <Route
      path={path}
      {...rest}
      render={props => {
        return isAuthenticated && user && roles && Object.keys(roles).length ? (
          <Component {...props} />
        ) : !isAuthenticated ? (
          <Redirect
            to={{
              pathname: _hostKey ? `/login/${_hostKey}` : '/login',
              state: { from: rest.location }
            }}
          />
        ) : null;
      }}
    />
  );
};

export default ProtectedRoute;
